// extracted by mini-css-extract-plugin
export default {"fullscreenContainer":"root_fullscreenContainer__btXc0"};